import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { NewResidentBanner, Radio } from "./styles";
import { Column } from "../../../table/Column";
import { CellRenderer } from "./CellRenderer";
import { Table } from "../../../table/Table";
import { NEW_RESIDENT } from "./types";
import { normalizeString, parseDate } from "./utils/helpers";
export const NewResident = ({ formValues, selectable = true, hasSimilarResidents = false, hasDuplicate = false, duplicateResident, residentFilesModal, }) => {
    const NEW_RESIDENT_TABLE_ITEM = React.useMemo(() => ({
        match: NEW_RESIDENT,
        resident: { ...formValues, id: NEW_RESIDENT },
    }), [formValues]);
    const areStringsEqual = React.useCallback((val1, val2) => {
        return normalizeString(val1 || "") === normalizeString(val2 || "");
    }, []);
    return (_jsx(NewResidentBanner, { hasSimilarResidents: hasSimilarResidents, hasDuplicate: hasDuplicate, selectable: selectable, children: _jsxs(Table, { data: hasDuplicate ? [duplicateResident] : [NEW_RESIDENT_TABLE_ITEM], getRowId: ({ rowData }) => rowData?.resident?.id || "unknown", children: [_jsx(Column, { cellRenderer: ({ rowData }) => {
                        return (_jsx(Radio, { id: "similar_resident_radio", onClick: (e) => {
                                e.stopPropagation();
                            }, visible: selectable, name: "resident_demographics.similar_resident", type: "radio", value: rowData.resident.id }));
                    }, width: 100 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({
                        label: "First name",
                        value: rowData.resident.first_name || "—",
                    }, areStringsEqual(formValues.first_name, rowData.resident.first_name)), label: "First Name", width: 250 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({
                        label: "Last name",
                        value: rowData.resident.last_name || "—",
                    }, areStringsEqual(formValues.last_name, rowData.resident.last_name)), label: "Last Name", width: 250 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({ label: "Gender", value: rowData.resident.gender || "—" }, formValues.gender === rowData.resident.gender), label: "Gender", width: 150 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({
                        label: "Date of birth",
                        value: rowData.resident.date_of_birth
                            ? parseDate(rowData.resident.date_of_birth)
                            : "—",
                    }, formValues.date_of_birth === rowData.resident.date_of_birth), label: "Date of Birth", width: 150 }), _jsx(Column, { cellRenderer: ({ rowData, rowIndex }) => {
                        return (hasDuplicate &&
                            residentFilesModal && (_jsx("div", { style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "16px",
                            }, children: residentFilesModal({
                                rowData,
                                rowIndex,
                            }) })));
                    }, width: hasDuplicate ? 150 : 10 })] }) }));
};
